export default class {
    _id;
    _branchName;
    _branchCode;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get branchName() {
        return this._branchName;
    }

    set branchName(value) {
        this._branchName = value;
    }

    get branchCode() {
        return this._branchCode;
    }

    set branchCode(value) {
        this._branchCode = value;
    }
}
